import type { IntakeStatus } from '../services/api/types.gen';

/**
 * Intake status constants for use throughout the application.
 * These map to the IntakeStatus type from the API.
 */
export const INTAKE_STATUS = {
  RECEIVED: 'received' as IntakeStatus,
  PENDING_REVIEW: 'pending_review' as IntakeStatus,
  UNDER_REVIEW: 'under_review' as IntakeStatus,
  PENDING_CLARIFICATION: 'pending_clarification' as IntakeStatus,
  PENDING_ELIGIBILITY: 'pending_eligibility' as IntakeStatus,
  PENDING_PRIOR_AUTH: 'pending_prior_auth' as IntakeStatus,
  READY_TO_CALL: 'ready_to_call' as IntakeStatus,
  ACCEPTED: 'accepted' as IntakeStatus,
  SCHEDULED: 'scheduled' as IntakeStatus,
  PUSHED_TO_KINNSER: 'pushed_to_kinnser' as IntakeStatus,
  PUSHED_TO_ROGER: 'pushed_to_roger' as IntakeStatus,
  PUSH_FAILED: 'push_failed' as IntakeStatus,
  REJECTED: 'rejected' as IntakeStatus,
  DUPLICATE: 'duplicate' as IntakeStatus,
  EXPIRED: 'expired' as IntakeStatus,
} as const;

/**
 * Statuses from which no further EMR push activity can occur: the push
 * outcomes themselves, the reviewed dead-ends (rejected/duplicate/expired),
 * and the push_failed lockout. Mirrors the backend's
 * PUSH_TERMINAL_INTAKE_STATUSES (app/models/enum/intake.py).
 */
export const PUSH_TERMINAL_INTAKE_STATUSES: readonly IntakeStatus[] = [
  INTAKE_STATUS.PUSHED_TO_KINNSER,
  INTAKE_STATUS.PUSHED_TO_ROGER,
  INTAKE_STATUS.PUSH_FAILED,
  INTAKE_STATUS.REJECTED,
  INTAKE_STATUS.DUPLICATE,
  INTAKE_STATUS.EXPIRED,
];

/** Whether an intake status is terminal for EMR-push purposes. */
export function isPushTerminalIntakeStatus(
  status: string | null | undefined
): boolean {
  return (PUSH_TERMINAL_INTAKE_STATUSES as readonly string[]).includes(
    status ?? ''
  );
}
